<card-container>
  <card title="Báo cáo xuất nhập tồn theo mã hàng"
        description="Thống kê thông tin xuất, nhập, tồn hàng hóa theo từng mã hàng, mã màu"
        icon="fa fa-boxes text-warning"
        routerLink="/reports/inventory-report-by-products"></card>

  <card title="Báo cáo xuất nhập theo khách hàng"
        description="Thống kê thông tin xuất, nhập, trả hàng theo từng khách hàng, mã hàng, mã màu"
        icon="fa fa-user-tie text-warning"
        routerLink="/reports/inventory-report-by-customers"></card>

  <card title="Báo cáo xuất nhập theo đơn nhập"
        description="Thống kê thông tin xuất, nhập, tồn hàng hóa theo đơn nhập, mã hàng, mãu màu"
        icon="fa fa-arrow-circle-down text-warning"
        routerLink="/reports/inventory-report-by-imports"></card>

  <card title="Báo cáo đặt hàng theo mã hàng"
        description="Thống kê số lượng đặt hàng, biến động giá nhập, xuất, tỷ giá theo mã hàng, mãu màu, khách hàng"
        icon="fa fa-file-upload text-success"
        routerLink="/reports/price-report-by-products"></card>

  <card title="Báo cáo thu chi"
        description="Thống kê các khoản thu, chi theo thời gian, danh mục"
        icon="fa fa-chart-pie text-danger"
        routerLink="/reports/payment-report"></card>

  <card title="Hạch toán"
        description="Hạch toán lỗ lãi, thống kê công nợ, tiền đã thu, chi theo các hạng mục lớn"
        icon="fa fa-check-circle text-danger"
        routerLink="/reports/general-report"></card>
</card-container>
